import { isDefined } from "@ls/js-utils";
import { immerable } from "immer";
import SummaryType from "state/selections/Constants/SummaryType";
import scope from "./scope";

export const getDefault = () => {
  return new RatingDefinition({
    ratingId: "defaultRating",
    analytic: "qualityRatingNumeric",
    summary: SummaryType.ABSOLUTE,
    ratingMode: { value: "STANDARD" },
    ratingMetric: { value: "RATING" },
  });
};

export default class RatingDefinition {
  [immerable] = true;

  constructor(props) {
    const { ratingId, analytic, summary, ratingMode, ratingMetric } = props;
    this.ratingId = ratingId;
    this.analytic = analytic; //ratings are just analytics under the hood
    this.summary = summary;
    this.ratingMode = ratingMode ?? { value: "STANDARD" }; //for backwards compatibility, since ratingMode did not exist before
    this.ratingMetric = ratingMetric ?? { value: "RATING" };
    this.key = `${scope} - ${ratingId}, ${summary}, ${ratingMode?.value}, ${ratingMetric?.value}`;
    this.complete = isDefined(this.ratingId);
  }
}
